<template>
    <div v-loading="!finishGetList">
        <style-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"
                           :paginationData="filterSet.page" :sortData="filterSet.sort"></style-filter-link>
        <style-list-link :listLayout="listLayout" :styleData="List" :paginationData="filterSet.page"
                         :sortData="filterSet.sort"></style-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"></pagination-link>
    </div>
</template>

<script>
import StyleFilterLink from "@/components/style/StyleFilterLink";
import StyleListLink from "@/components/style/StyleListLink";
import PaginationLink from "@/components/style/PaginationLink";
import styleUtil from "@/components/style/styleUtil";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";

const {filterConfig} = styleUtil;
export default {
    name: "StyleListComponent",
    mixins: [alertMixins, styleUtil, filterMixins, listMixins],
    components: {
        PaginationLink,
        StyleListLink,
        StyleFilterLink
    },
    inject: [],
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            setFilterNotParser: this.setFilterNotParser,
            setSort: this.setSort,
            setSortNotParser: this.setSortNotParser,
        }
    },
    props: {
        styleType: '',
    },
    data() {
        return {
            filterLayout: '',
            listLayout: '',
            paginationLayout: '',
            listApiParamSet: {},
            getFunc: '',
            pageRow: '',
            keyName: '',
        }
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig);
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        this.getList(true);
    },
    beforeRouteLeave(to, from, next) {

    },
    beforeDestroy() {
    },
    computed: {},
    watch: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },

        initConfig() {
            let config = this.returnStyleConfig(this.styleType);
            this.listLayout = config.listLayout;
            this.filterLayout = config.filterLayout;
            this.paginationLayout = config.paginationLayout;

            this.listApiParamSet = config.listApiParamSet;

            this.getFunc = config.getFunc;

            this.listApiParamSet = Object.assign({}, this.listApiParamSet, this.defaultFilter);
            // let defaultParams = Object.assign({}, this.listApiParamSet, this.defaultFilter);

            if (config.pageRow && config.pageRow != this.filterSet.page.size) {
                this.pageRow = config.pageRow;
                this.filterSet.page.size = config.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }

            let listOptions = {
                url: this.$api.$style[this.getFunc],
                defaultParams: this.listApiParamSet,
                // defaultParams:defaultParams,
            }
            this.initList('api', listOptions);
        },
    }
}
</script>

<style scoped>

</style>
